import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RespuestaAPI } from "src/interface/api-responses.model";
import { environment } from 'src/environments/environment';
import { Observable, Subject } from "rxjs";


const API = "https://admin.api.municipios.saion.mx";

@Injectable({
  providedIn: 'root'
})

export class Fraccion1Service{

  constructor(private http:HttpClient){}

  //---Observable para indicar URL de foto obtenida---
  urlFoto: any;
  private subject = new Subject<any>();
  url: string = API + "/";


  obtenerA8(id: any, inciso: any, ano:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/${id}/${inciso}/${ano}/${carpeta}/${municipios}`);
  }

  obtenerA82018(id: any, inciso: any, ano:any, carpeta:any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/dif/${id}/${inciso}/${ano}/${carpeta}/${dif}`);
  }
  obtenerA8MES(id: any, inciso: any, ano:any, mes:any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/dif/mes/${id}/${inciso}/${ano}/${mes}/${dif}`);
  }

  obtenerA8Carpeta(id: any, inciso: any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/dif/carpeta/${id}/${inciso}/${dif}`);
  }
  obtenerA8Carpetas(id: any, inciso: any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/dif/carpetas/${id}/${inciso}/${dif}`);
  }
  obtenerA8año(id: any, inciso: any, ano:any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/dif/ano/${id}/${inciso}/${ano}/${dif}`);
  }

  obtenerA(id: any, inciso: any, ano:any, carpeta:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/${id}/${inciso}/${ano}/${carpeta}/${municipios}`);
  }

  obtenerA15año(id: any, inciso: any, ano:any, municipios:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/ano/${id}/${inciso}/${ano}/${municipios}`);
  }
  obtenerAreas(id:any, inciso:any, ano:any, area:any, dif:any){
    return this.http.get<RespuestaAPI>(API +`/municipios/dif/area/${id}/${inciso}/${area}/${ano}/${dif}`);
  }
  obtenerarpetaMes(id: any, inciso: any, ano:any, mes:any, carpeta:any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/bienes/${id}/${inciso}/${ano}/${mes}/${carpeta}/${dif}`);
  }

  obtenertrimestres(id: any, inciso: any, ano:any, area:any, carpeta:any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A86L/${id}/${inciso}/${ano}/${area}/${carpeta}/${dif}`);
  }
  obtenerNoticia(id: any, dif:any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/DIF/obtenerNoticia/${id}/${dif}`);
  }





















}
